// extracted by mini-css-extract-plugin
export var almostBlack = "#333";
export var almostWhite = "#f0f0f0";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var container = "index-module--container--mPFri";
export var coolGrey = "#e1e2e0";
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var darkGrey = "#4b4d4b";
export var error = "#f66a83";
export var footerLink = "index-module--footerLink--A1FiQ";
export var green = "#3dae2b";
export var grey = "#828382";
export var leftAlignment = "index-module--leftAlignment--UMvQp";
export var lightGreen = "#93d500";
export var lightGrey = "#aba9a9";
export var moduleRoot = "index-module--moduleRoot--BMTWi";
export var orange = "#fc9948";
export var paleBlue = "#64a1bb";
export var paragraphWrapper = "index-module--paragraphWrapper--u0N+s";
export var success = "#1ebc7b";
export var title = "index-module--title--a6Ji6";
export var titleParagraph = "index-module--titleParagraph--gLYuc";
export var warning = "#ffeda0";
export var white = "#fff";
export var yellow = "#fbc900";